
import { useEffect, useState, createContext } from 'react';
import AppLocalStorage from "../storage/localStorage";


export const appContext = createContext({});

const AppContextProvider = (props) => {

    let initialState = {
        view:'HOME',
        user:{},
        mockAPI:null,
        targetAPI: 'https://api.sample-service.dev',
        menuBarButtons:{left:true,center:true,right:true},
        requests:[]
    }
    let savedInitialState = AppLocalStorage.get()
    //savedInitialState = false
    if (savedInitialState) {
        initialState = savedInitialState
        initialState.editorBody = null
        initialState.editorBodyID = null
    }
    //savedInitialState.view = 'PLAYGROUND'
    const [appState, setAppState] = useState(initialState);  // this state will be shared with all components
    return (
        <appContext.Provider value={{appStateContextValue:[appState, setAppState]}}>
            {props.children}
        </appContext.Provider>
    );
};

export default AppContextProvider;